import { BaseObject } from "./BaseObject";
import { RenderLayer } from "../../api";
import { LineSegments, Mesh, Points, Sprite } from "three";
export class DrawableObject extends BaseObject {
    constructor() {
        super(...arguments);
        this.visible = true;
        this.renderLayer = RenderLayer.Main;
    }
    getVisible() {
        return this.visible;
    }
    setVisible(visible) {
        this.visible = visible;
    }
    asDrawableObject() {
        return this;
    }
    getRenderLayer() {
        return this.renderLayer;
    }
    setRenderLayer(layer) {
        this.renderLayer = layer;
    }
    dispose() {
        this.object.traverse((v) => {
            if (v instanceof Mesh || v instanceof Points || v instanceof LineSegments || v instanceof Sprite) {
                if (v.geometry) {
                    v.geometry.dispose();
                }
                if (v.material) {
                    if (v.material.map)
                        v.material.map.dispose();
                    if (v.material.lightMap)
                        v.material.lightMap.dispose();
                    if (v.material.bumpMap)
                        v.material.bumpMap.dispose();
                    if (v.material.normalMap)
                        v.material.normalMap.dispose();
                    if (v.material.specularMap)
                        v.material.specularMap.dispose();
                    if (v.material.envMap)
                        v.material.envMap.dispose();
                    if (v.material.alphaMap)
                        v.material.alphaMap.dispose();
                    if (v.material.aoMap)
                        v.material.aoMap.dispose();
                    if (v.material.displacementMap)
                        v.material.displacementMap.dispose();
                    if (v.material.emissiveMap)
                        v.material.emissiveMap.dispose();
                    if (v.material.gradientMap)
                        v.material.gradientMap.dispose();
                    if (v.material.metalnessMap)
                        v.material.metalnessMap.dispose();
                    if (v.material.roughnessMap)
                        v.material.roughnessMap.dispose();
                    v.material.dispose();
                }
            }
        });
    }
}
